function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M96.824 72H100c6.075 0 11 4.925 11 11v12h-6V84a6 6 0 00-6-6h-2.176v-6z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M97.324 72.5v5H99a6.5 6.5 0 016.5 6.5v10.5h5V83c0-5.799-4.701-10.5-10.5-10.5h-2.676z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M7 86h85v9H7z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M7.5 86.5h84v8h-84z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M5 0h89a5 5 0 015 5v77a5 5 0 01-5 5H5a5 5 0 01-5-5V5a5 5 0 015-5z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M5 .5A4.5 4.5 0 00.5 5v77A4.5 4.5 0 005 86.5h89a4.5 4.5 0 004.5-4.5V5A4.5 4.5 0 0094 .5H5zM38 33l7 7m0-7l-7 7m16-7l7 7m0-7l-7 7"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M66 53.5c-4.477-.567-10.87-1-16.262-1-6.087 0-11.866.29-16.738 1M9.5 9.5h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 4h15m7-68h15m-15 8h15m-15-4h15m-15 8h15m-15 44h15m-15 4h15m-15 4h15m-15 4h15m7-68h15m-15 8h15m-15-4h15m-15 8h15m-15 44h15m-15 4h15m-15 4h15m-15 4h15m7-68h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 4h15"
}));

function SvgEmergencyHvac(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 95,
    viewBox: "0 0 111 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyHvac);
export default __webpack_public_path__ + "static/media/EmergencyHvac.14922999.svg";
export { ForwardRef as ReactComponent };